import request from '../utils/request.js'

export default {
	getList(params) {
		return request.post(`process/lists`, params).then(res => res.data);
	},
	add(params) {
		return request.post(`process/add`, params).then(res => res.data);
	},
	edit(params) {
		return request.post(`process/add`, params).then(res => res.data);
	},
	details(params) {
		return request.post(`process/details`, params).then(res => res.data);
	},
	delete(params) {
		return request.post(`process/del`, params).then(res => res.data);
	},

	selectList(params) {
		return request.post(`process/lists`, params).then(res => res.data);
	},

	getLastStep(params) {
		return request.post(`process/get_last_step`, params).then(res => res.data);
	},

  	getInsertField(params) {
		return request.post(`process/get_insert_field`, params).then(res => res.data);
	},
  	getTicketConfig(params) {
		return request.post(`process/get_ticket_config`, params).then(res => res.data);
	},
  	saveTicketConfig(params) {
		return request.post(`process/ticket_config_save`, params).then(res => res.data);
	},
	exportNoprint(params) {
		return request.post(`process/export_noprint`, params).then(res => res.data);
	},



}



// WEBPACK FOOTER //
// ./src/api/process.js